<template>
  <AppLayout>
    <router-view></router-view>
  </AppLayout>
</template>

<script setup name="App">
import { onMounted } from "vue";
import AppLayout from "@/layout/AppLayout.vue";
import { useGlobalErrorLog } from "@/hooks/use-error-log";
import "@/styles/stylesheet.css";

onMounted(() => {
  //lanch the errorLog collection
  useGlobalErrorLog();
});
</script>

<style scoped>
html,
body {
  height: 100vh;
  margin: 0;
  padding: 0;
}

#app {
  height: inherit !important;
  width: inherit !important;
}
#nprogress .bar {
  background: var(--pregress-bar-color) !important;
}
</style>
